import { Tab } from './types.js';
import { toTab } from './utils.js';
import type { UsePrefState } from '#~/preferences/hooks.js';
import { usePrefState } from '#~/preferences/hooks.js';

/** @internal */
export const useLeftTabPref = (): UsePrefState<Tab> =>
  usePrefState('room.left.tab', Tab.Video, {
    deserialize: toTab
  });
